import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getAPIURL } from '../../../../../utils/utils';

// Fetch all DPBeneficiaries
export const getAllDPBeneficiaries = createAsyncThunk(
  'dpBeneficiaries/getAllDPBeneficiaries',
  async () => {
    const response = await axios.get(`${getAPIURL()}/getAll/dp-beneficiaries`);
    return response.data.getAllDpBeneficiaries;
  }
);

// Fetch DPBeneficiary by ID
export const getDPBeneficiaryById = createAsyncThunk(
  'dpBeneficiaries/getDPBeneficiaryById',
  async (beneficiaryId) => {
    const response = await axios.get(`${getAPIURL()}/getById/dp-beneficiaries/${beneficiaryId}`);
    return response.data.getAllDpBeneficiaries;
  }
);

// Add a new DPBeneficiary
export const createDPBeneficiary = createAsyncThunk(
  'dpBeneficiaries/createDPBeneficiary',
  async (beneficiaryData) => {
    const response = await axios.post(`${getAPIURL()}/create/dp-beneficiaries`, beneficiaryData);
    return response.data;
  }
);

// Update an existing DPBeneficiary
export const updateDPBeneficiary = createAsyncThunk(
  'dpBeneficiaries/updateDPBeneficiary',
  async ({ id, beneficiaryData }) => {
    const response = await axios.put(`${getAPIURL()}/update/dp-beneficiaries/${id}`, beneficiaryData);
    return response.data.getAllDpBeneficiaries;
  }
);

// Delete a DPBeneficiary
export const deleteDPBeneficiary = createAsyncThunk(
  'dpBeneficiaries/deleteDPBeneficiary',
  async (beneficiaryId) => {
    const response = await axios.delete(`${getAPIURL()}/delete/dp-beneficiaries/${beneficiaryId}`);
    return response.data;
  }
);

const dpBeneficiariesSlice = createSlice({
  name: 'dpBeneficiaries',
  initialState: {
    dpBeneficiaries: [], // This will hold all beneficiaries when fetched
    loading: false,
    error: null,
    selectedBeneficiary: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDPBeneficiaries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllDPBeneficiaries.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.dpBeneficiaries = action.payload; // Update dpBeneficiaries with all beneficiaries
      })
      .addCase(getAllDPBeneficiaries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getDPBeneficiaryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDPBeneficiaryById.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.selectedBeneficiary = action.payload; // Update selectedBeneficiary with the fetched beneficiary
      })
      .addCase(getDPBeneficiaryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createDPBeneficiary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDPBeneficiary.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createDPBeneficiary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateDPBeneficiary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDPBeneficiary.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBeneficiary = action.payload;
      })
      .addCase(updateDPBeneficiary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteDPBeneficiary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDPBeneficiary.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
 })
      .addCase(deleteDPBeneficiary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default dpBeneficiariesSlice.reducer;